import React from 'react';
import Router from './components/Router';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <Router />
      </div>
    </ErrorBoundary>
  );
}

export default App;
